import React from 'react';
import styled from 'styled-components';
import { ITileFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { theme } from '../../../../styles/theme';
import { IconName, SvgIcon } from '../../../../components/Icon';
import findIcon from '../../../../components/Icon/findIcon';
import TileActions from './TileActions';
import { tileItemStyles } from '../TilesUI';
import {
  optionHover,
  overflowingStyles,
} from '../../../../styles/shareableStyles';

interface IProps {
  tile: ITileFieldsFragment;
  isPermittedToEdit: boolean;
}

const StyledActions = styled(TileActions)`
  opacity: 0;
`;
const Description = styled.div`
  max-width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${theme.colors.secondary600};
  ${overflowingStyles};
`;
const Container = styled.a`
  display: flex;
  column-gap: 6px;
  color: ${theme.colors.secondary800};
  ${tileItemStyles};
  &:hover {
    border-color: ${theme.colors.blue500};
    ${optionHover};
    cursor: pointer;

    ${StyledActions} {
      opacity: 1;
    }
    ${Description} {
      color: ${theme.colors.mainBlue};
    }
  }
`;
const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  column-gap: 6px;
  width: 100%;
  justify-content: space-between;
`;
const Title = styled.div`
  max-width: 100%;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  color: currentColor;
  ${overflowingStyles};
`;

const TileItem = ({ tile, isPermittedToEdit }: IProps) => {
  const { title, description, url } = tile;
  const icon = findIcon(tile.icon as IconName);

  return (
    <Container href={url} target="_blank" rel="noopener noreferrer">
      <SvgIcon name={icon} width={32} height={32} customFill="currentColor" />
      <Wrapper>
        <div>
          <Title title={title}>{title}</Title>
          <Description title={description}>{description}</Description>
        </div>
        {isPermittedToEdit && <StyledActions tile={tile} />}
      </Wrapper>
    </Container>
  );
};

export default TileItem;
